<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card class="elevation-2">
            <v-card-actions>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  xl="3"
                >
                  <v-text-field
                    v-model="search"
                    placeholder="Key in employee name here"
                    append-icon="search"
                    label="Search Employee"
                    hide-no-data
                    hide-selected
                    clearable 
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  xl="4"
                >
                  <v-autocomplete
                    v-model="leaveType"
                    :items="leaveTypes"
                    multiple
                    item-text="name"
                    item-value="id"
                    hide-no-data
                    chips
                    small-chips
                    deletable-chips
                    hide-selected
                    label="Leave Type Filter"
                    placeholder="Choose leave type"
                    @change="loadData(leaveType)"
                  />
                </v-col>
                <v-spacer />
                <v-col
                  cols="12"
                  md="2"
                  xl="2"
                >
                  <setup-leaves-entitlements-dialog-copy 
                    @copied="loadNextYearData"
                  /> 
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  xl="2"
                >
                  <setup-leaves-entitlements-dialog-create
                    @created="loadData(leaveType)"
                  />
                </v-col>
              </v-row>
            </v-card-actions>
            <v-data-table
              ref="leaveEntitlement"
              :headers="headers"
              :items="entitlements"
              :loading="loading"
              :search="search"
              single-expand
              item-key="id"
            >
              <template v-slot:item.employee.person.name="{ item }">
                {{ item.employee.person.name }}
                <setup-leaves-entitlements-dialog-list-all
                  v-if="item.total_adjusted_days"
                  :entitlement="item"
                  @updated="loadData(leaveType)"
                />
              </template>
              <template v-slot:item.leave_type.name="{ item }">
                {{ item.leave_type.name }}
                <!-- ONLY FOR PRORATED LEAVES -->
                <setup-leaves-entitlements-dialog-forecast-prorated-days
                  v-if="item.leave_type.is_prorated == 1"
                  :entitlement="item"
                />
                <!-- ONLY FOR PRORATED LEAVES -->
              </template>
              
              <template v-slot:item.prorated_days="{ item }">
                <span style="display:inline-block;width:40px">
                  {{ item.prorated_days }}
                </span>
                <!-- <v-tooltip
                  v-if="item.leave_type.is_prorated && item.prorated_days!=item.correct_prorated_days"
                  bottom
                >
                  <template v-slot:activator="{ on: tooltip }">
                    <v-icon
                      color="warning"
                      v-on="{ ...tooltip }"
                    >
                      mdi-alert-circle
                    </v-icon>
                  </template>
                  <span>Prorated Days is not correct until end of current month</span>
                </v-tooltip> -->
                
                <!-- <setup-leaves-entitlements-dialog-recalculate-prorated-days
                  v-if="item.prorated_days"
                  :entitlement="item"
                  @updated="loadData(leaveType)"
                /> -->
              </template>
              <template v-slot:item.entitled_days_taken="{ item }">
                <div>
                  <span v-if="item.entitled_days_taken">
                    {{ (Number(item.entitled_days_taken) + Number(item.carried_forward_days_taken)).toFixed(2) || '0.00' }}
                    <setup-leaves-entitlements-dialog-view-leave-applications
                      :entitlement="item"
                      @cancel="loadData(leaveType)"
                    />
                  </span>
                  <span v-else>
                    N/A
                  </span>
                </div>
              </template>
              <template v-slot:item.carried_forward_days="{ item }">
                <div>
                  <span v-if="item.carried_forward_days">
                    {{ item.carried_forward_days }}
                  </span>
                  <span v-else>
                    N/A
                  </span>
                </div>
              </template>
              <template v-slot:item.total_adjusted_days="{ item }">
                <span style="display:inline-block;width:40px">
                  {{ item.total_adjusted_days.toFixed(2) || '0.00' }}
                </span>
                <setup-leaves-entitlements-dialog-adjustment
                  :entitlement="item"
                  @updated="loadData(leaveType)"
                />
              </template>
              <template v-slot:item.maximum_carry_forward_amount="{ item }">
                <div>
                  <span v-if="item.maximum_carry_forward_amount">
                    {{ item.maximum_carry_forward_amount }}
                  </span>
                  <span v-else>
                    N/A
                  </span>
                </div>
              </template>

              <template v-slot:item.available_days="{ item }">
                <div>
                  <span v-if="item.available_days">
                    {{ item.available_days || '0.00' }}
                  </span>
                  <span v-else>
                    N/A
                  </span>
                </div>
              </template>

              <template v-slot:item.available_carry_forward="{ item }">
                <div>
                  <span
                    v-if="item.available_carry_forward"
                    class="font-weight-bold"
                  >
                    {{ item.available_carry_forward || '0.00' }}
                  </span>
                  <span v-else>
                    N/A
                  </span>
                </div>
              </template>
              <template v-slot:item.action="{ item }"> 
                <!-- <setup-leaves-entitlements-dialog-edit
                  :entitlement="item"
                  @updated="loadData(leaveType)"
                />     -->
                <setup-leaves-entitlements-dialog-delete
                  :entitlement="item"
                  @deleted="loadData(leaveType)"
                />
              </template>
            </v-data-table>     
          </v-card>  
        </v-col>
      </v-row>
      <span class="subtitle-2 font-weight-medium font-italic">
        <div>
          <span class="font-weight-bold">Legend: </span>
          <span class="font-weight-bold">ED</span> = Entitled Days, 
          <span class="font-weight-bold">PD</span> = Prorated Days, 
          <span class="font-weight-bold">AD</span> = Adjusted Days, 
          <span class="font-weight-bold">CFD</span> = Carried Forward Days, 
          <span class="font-weight-bold">CF</span> = Carried Forward, 
          <span class="font-weight-bold">MCFD</span> = Maximum Carry Forward Days
        </div>
      </span>
    </v-container>
  </div>
</template>

<script>
  export default {
    components: {
      SetupLeavesEntitlementsDialogCopy: () => import('@/components/setup/leaves/entitlements/DialogCopy'),
      SetupLeavesEntitlementsDialogCreate: () => import('@/components/setup/leaves/entitlements/DialogCreate'),
      // SetupLeavesEntitlementsDialogEdit: () => import('@/components/setup/leaves/entitlements/DialogEdit'),
      SetupLeavesEntitlementsDialogDelete: () => import('@/components/setup/leaves/entitlements/DialogDelete'),
      SetupLeavesEntitlementsDialogAdjustment: () => import('@/components/setup/leaves/entitlements/DialogAdjustment'),
      SetupLeavesEntitlementsDialogListAll: () => import('@/components/setup/leaves/entitlements/DialogListAll'),
      // SetupLeavesEntitlementsDialogRecalculateProratedDays: () => import('@/components/setup/leaves/entitlements/DialogRecalculateProratedDays'),
      SetupLeavesEntitlementsDialogForecastProratedDays: () => import('@/components/setup/leaves/entitlements/DialogForecastProratedDays'),
      SetupLeavesEntitlementsDialogViewLeaveApplications: () => import('@/components/setup/leaves/entitlements/DialogViewLeaveApplications'),
    },
    data () {
      return {
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'employee.person.name',
          },
          {
            text: 'Leave Type',
            align: 'left',
            value: 'leave_type.name',
          },
          {
            text: 'Start Date',
            align: 'left',
            sortable: false,
            value: 'start_date',
          },
          {
            text: 'ED',
            align: 'left',
            sortable: false,
            value: 'entitled_days',
          },
          {
            text: 'PD',
            align: 'left',
            sortable: false,
            value: 'prorated_days',
          },
          {
            text: 'CFD',
            align: 'left',
            sortable: false,
            value: 'carried_forward_days',
          },
          {
            text: 'AD',
            align: 'center',
            sortable: false,
            value: 'total_adjusted_days',
          },
          {
            text: 'ED Taken',
            align: 'left',
            sortable: false,
            value: 'entitled_days_taken',
          },
          {
            text: 'Balance',
            align: 'left',
            sortable: false,
            value: 'available_days',
          },
          {
            text: 'MCFD',
            align: 'left',
            sortable: false,
            value: 'maximum_carry_forward_amount',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],  
        loading: false,
        entitlements: [],
        leaveTypes: [],
        leaveType: [1],
        search: '',     
      }
    },

    created () {
      this.loadData(this.leaveType)
    },

    methods: {
      loadNextYearData () {
        this.loadData(this.leaveType)
      },
      loadData (leaveType) {
        this.loading = true
        
        Promise.all([
          this.$api.leaveEntitlements().list(leaveType),
          this.$api.leaveTypes().list(),
        ])
          .then(([entitlement, leaveType]) => {
            this.entitlements = _.orderBy(entitlement.data, ['employee.person.name', 'leave_type.name'], ['asc', 'asc'])       
            this.leaveTypes = _.orderBy(leaveType.data, ['name'], ['asc'])   

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
  ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }

  ::v-deep .v-table__overflow{
    overflow-x: hidden;
  }
</style>
